import React from "react";
import { PortfolioData } from "../types/portfolio";

interface HeroProps {
  data: PortfolioData;
}

const Hero: React.FC<HeroProps> = ({ data }) => {
  const handleResumeClick = () => {
    // Open PDF in new tab (which allows browser to handle download)
    window.open('/resume/Divya_resume.pdf', '_blank');
  };

  

  return (
    <section
      id="hero"
      className="min-h-screen bg-gradient-to-b from-navy via-deep-blue to-navy text-white flex items-center justify-center"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex flex-col justify-center items-center text-center">
          {/* Content */}
          <div className="animate-fadeInUp w-full max-w-3xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-manrope font-bold mb-3 sm:mb-4 text-white leading-tight">
              {data.personal.name}
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-gold mb-4 sm:mb-6 font-manrope font-semibold">
              {data.personal.title}
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-200 mb-6 sm:mb-8 leading-relaxed mx-auto max-w-2xl">
              {data.personal.intro}
            </p>
            <p className="text-xs sm:text-sm md:text-base text-teal mb-8 sm:mb-10 font-semibold flex items-center justify-center">
              <span className="inline-block w-2 h-2 bg-teal rounded-full mr-2 flex-shrink-0"></span>
              {data.personal.location}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8 sm:mb-12 justify-center">
              <a
                href="#experience"
                className="px-4 sm:px-6 md:px-8 py-3 bg-gold text-navy font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 text-center w-full sm:w-auto text-sm sm:text-base"
              >
                Explore My Experience
              </a>
              <button
                onClick={handleResumeClick}
                className="px-4 sm:px-6 md:px-8 py-3 border-2 border-gold text-gold font-semibold rounded-lg hover:bg-gold hover:text-navy transition-all duration-300 w-full sm:w-auto text-sm sm:text-base"
              >
                Download Resume
              </button>
            </div>

            {/* Contact Links */}
            <div className="flex flex-wrap gap-4 sm:gap-6 items-center justify-center">
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${data.personal.email}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors duration-300 flex items-center gap-2 text-xs sm:text-sm md:text-base"
                title="Send Email"
              >
                <svg
                  className="w-5 h-5 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
                <span className="hidden sm:inline">Email</span>
              </a>

              {data.social.linkedin && (
                <a
                  href={data.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gold hover:text-white transition-colors duration-300 flex items-center gap-2 text-xs sm:text-sm md:text-base"
                  title="LinkedIn"
                >
                  <svg
                    className="w-5 h-5 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                  </svg>
                  <span className="hidden sm:inline">LinkedIn</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
